import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(main)/leaderboard/LeaderboardClient.tsx");
